import React, { useContext, useMemo } from "react"

import { ProductConfiguratorProps } from "../ProductConfigurator"

export interface ProductConfiguratorStatusContextType {
  isConfigurable?: boolean
  isConfigurationModelFaulty?: boolean
  isConfigurationServiceAvailable?: boolean
  isConfigurationWip?: boolean
}

export const DEFAULT_PRODUCT_CONFIGURATOR_STATUS_CONTEXT: ProductConfiguratorStatusContextType =
  {}

export const ProductConfiguratorStatusContext =
  React.createContext<ProductConfiguratorStatusContextType>(
    DEFAULT_PRODUCT_CONFIGURATOR_STATUS_CONTEXT
  )

export function useProductConfiguratorStatusContext(): ProductConfiguratorStatusContextType {
  return useContext(ProductConfiguratorStatusContext)
}

export function useProductConfiguratorStatusContextValue(
  model: ProductConfiguratorProps
): ProductConfiguratorStatusContextType {
  const {
    isConfigurable,
    isConfigurationModelFaulty,
    isConfigurationServiceAvailable,
    isConfigurationWip
  } = model

  return useMemo<ProductConfiguratorStatusContextType>(
    () => ({
      isConfigurable,
      isConfigurationModelFaulty,
      isConfigurationServiceAvailable,
      isConfigurationWip
    }),
    [
      isConfigurable,
      isConfigurationModelFaulty,
      isConfigurationServiceAvailable,
      isConfigurationWip
    ]
  )
}

export function ProductConfiguratorStatusContextProvider({
  children,
  model
}: {
  children: React.ReactNode
  model: ProductConfiguratorProps
}) {
  const value = useProductConfiguratorStatusContextValue(model)

  return (
    <ProductConfiguratorStatusContext.Provider value={value}>
      {children}
    </ProductConfiguratorStatusContext.Provider>
  )
}
